const omit = (obj, paths) => {
  const result = { ...obj }
  const arrayPath = Array.isArray(paths) ? paths : [paths]

  arrayPath.forEach(prop => delete result[prop])
  return result
}

export default omit
